import type { TabProps, TabsState } from '@talos/kyoko';
import { getSpaceBasePath } from '../../../../components/NavigationSidebar/spacesNavPath';
import { toNavGroupName } from '../../../../hooks/useSpacesNavItems';
import type { LayoutSpec, PanelConfig } from '../../../../types/LayoutConfig';

type LayoutAddressable = Pick<LayoutSpec, 'id' | 'group'>;

export const getTradingLayoutBasePath = (layout: LayoutAddressable) =>
  getSpaceBasePath('trading', layout.group ? toNavGroupName(layout.group) : undefined, layout.id);

export const getTradingPanelRoute = (layout: LayoutAddressable, panelId: string) =>
  `${getTradingLayoutBasePath(layout)}/${panelId}`;

export const getBlotterTabRoute = (layout: LayoutAddressable, panelId: string, tabId: string) =>
  `${getTradingPanelRoute(layout, panelId)}/${encodeURIComponent(tabId)}`;

/** Pull persisted tab state out of the panel config, if the panel is one of the blotter types that supports tabs. */
export function getTabsStateFromPanelConfig(config: PanelConfig | undefined): TabsState<TabProps> | undefined {
  if (config != null && 'tabs' in config && config.tabs != null) {
    return config.tabs as TabsState<TabProps>;
  }
  return undefined;
}
